"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.primaryButtons = void 0;
var material_1 = require("@mui/material");
var common_1 = require("./common");
exports.primaryButtons = [
    {
        props: { variant: 'primaryDefault' },
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common_1.buttonsCommon), { color: "var(--text-light, ".concat(theme.palette.text.light, ")"), backgroundColor: theme.palette.secondary.main, '&:hover': {
                    backgroundColor: theme.palette.secondary.dark,
                }, '&:focus': {
                    backgroundColor: theme.palette.secondary.dark,
                }, '&:active': {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.secondary.light,
                }, '&:disabled': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.primary, 0.3),
                    color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                } }));
        },
    },
    {
        props: { variant: 'primaryHC' },
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common_1.buttonsCommon), { color: "var(--text-interactive, ".concat(theme.palette.text.interactive, ")"), backgroundColor: theme.palette.neutrals.white, '&:hover': {
                    backgroundColor: theme.palette.secondary.light,
                }, '&:focus': {
                    backgroundColor: theme.palette.secondary.light,
                }, '&:active': {
                    color: theme.palette.text.primary,
                    backgroundColor: theme.palette.neutrals.primary,
                }, '&:disabled': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.primary, 0.3),
                    color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                } }));
        },
    },
    {
        props: { variant: 'primaryAccent1' },
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common_1.buttonsCommon), { color: "var(--text-primary, ".concat(theme.palette.text.primary, ")"), backgroundColor: theme.palette.accent01.main, '&:hover': {
                    backgroundColor: theme.palette.accent01.dark,
                }, '&:focus': {
                    backgroundColor: theme.palette.accent01.dark,
                }, '&:active': {
                    backgroundColor: theme.palette.accent01.light,
                }, '&:disabled': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.primary, 0.3),
                    color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                } }));
        },
    },
    {
        props: { variant: 'primaryRed' },
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common_1.buttonsCommon), { color: "var(--text-light, ".concat(theme.palette.text.light, ")"), backgroundColor: theme.palette.error.dark, '&:hover': {
                    color: theme.palette.error.dark,
                    backgroundColor: theme.palette.error.main,
                }, '&:active': {
                    color: theme.palette.error.dark,
                    backgroundColor: theme.palette.error.light,
                }, '&:disabled': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.primary, 0.3),
                    color: "var(--text-disabled, ".concat(theme.palette.text.disabled, ")"),
                } }));
        },
    },
    {
        props: { variant: 'primaryDestructive' },
        style: function (_a) {
            var theme = _a.theme;
            return (__assign(__assign({}, common_1.buttonsCommon), { color: "var(--text-light, ".concat(theme.palette.text.light, ")"), backgroundColor: "var(--error-700, ".concat(theme.palette.error.dark, ")"), '&:hover': {
                    color: "var(--error-700, ".concat(theme.palette.error.dark, ")"),
                    backgroundColor: "var(--error-300, ".concat(theme.palette.error.light, ")"),
                }, '&:active': {
                    color: "var(--error-700, ".concat(theme.palette.error.dark, ")"),
                    backgroundColor: "var(--error-500, ".concat(theme.palette.error.main, ")"),
                }, '&:disabled': {
                    backgroundColor: (0, material_1.alpha)(theme.palette.neutrals.primary, 0.3),
                    color: theme.palette.text.disabled,
                } }));
        },
    },
];
